import React, { Component } from "react"
import { Dialog, FlatButton, SelectField, MenuItem } from "material-ui"
import strings from "../../../../../localization/strings"
import { IEmployeeStatus } from "../../../../../models"

interface IState {
    subStatuses: any[]
    selectedStatus: string
    selectedSubStatus: string
}

interface IProps {
    open: boolean
    onClose: () => void
    onStatusSelection: (data) => void
    statuses: IEmployeeStatus[]
}

export class UserStatusDialog extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            subStatuses: [],
            selectedStatus: "Choose",
            selectedSubStatus: "Choose"
        }
    }

    handleSelection = () => {
        const selected: IEmployeeStatus = this.props.statuses.find((x: IEmployeeStatus) => x.Id === this.state.selectedStatus)
        let sub = { Id: "", Name: "" }
        if (this.state.selectedSubStatus !== "Choose") {
            sub = selected.SubStatuses.find((x) => x.Id === this.state.selectedSubStatus)
        }
        this.props.onStatusSelection({ Status: selected, SubStatus: sub })
    }

    render() {
        const { open, onClose, statuses } = this.props
        const { selectedStatus, selectedSubStatus, subStatuses } = this.state
        return (
            <Dialog
                open={open}
                title={"Select Status"}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton label={strings.CANCEL} secondary onClick={onClose} />,
                    <FlatButton
                        label={strings.SAVE}
                        primary
                        disabled={selectedStatus === "Choose"}
                        onClick={this.handleSelection}
                    />
                ]}
            >
                <div style={{ display: "flex" }}>
                    <SelectField
                        floatingLabelText={strings.Status}
                        value={selectedStatus}
                        onChange={(event, key, state) => {
                            this.setState({ selectedStatus: state, subStatuses: statuses.find((x) => x.Id === state).SubStatuses },)
                        }}
                        style={{ flexGrow: "1", margin: "0px 10px" }}
                    >
                        <MenuItem value={"Choose"} primaryText={"Choose"} disabled />
                        {statuses
                            .sort((prev: IEmployeeStatus, next: IEmployeeStatus) => prev.Name.localeCompare(next.Name))
                            .map((status: IEmployeeStatus) => (
                                <MenuItem key={status.Id} value={status.Id} primaryText={status.Name} />
                            ))}
                    </SelectField>
                    {subStatuses&& subStatuses.length > 0 && <SelectField
                        floatingLabelText={strings.Substatus}
                        value={selectedSubStatus}
                        onChange={(event, key, state) => {
                            this.setState({ selectedSubStatus: state })
                        }}
                        style={{ flexGrow: "1", margin: "0px 10px" }}
                    >
                        <MenuItem value={"Choose"} primaryText={"Choose"} disabled />
                        {subStatuses.map((subStatus, index) => (
                            <MenuItem key={subStatus.Id} value={subStatus.Id} primaryText={subStatus.Name} />
                        ))}
                    </SelectField>}
                </div>
            </Dialog>
        )
    }
}

export default UserStatusDialog
